import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faSubscript } from '@fortawesome/pro-light-svg-icons';

export type ProLightSubscriptProps = IconComponentProps;

export const ProLightSubscript = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightSubscriptProps) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faSubscript}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faSubscript}
    />
  );
};

ProLightSubscript.displayName = 'ProLightSubscript';
